import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import Form from './Form';
import config from 'config';
import { ApiService } from '../../../services';
import { getPreviewSrc, encodeFileName } from '../../../helpers/filesPreview';

import './Edit.scss';

export interface ConsultorioRenovacionRequest {
  id: string | undefined;
  matriculado: {
    matricula: number;
    nombre: string;
    apellido: string;
    delegacion: string;
  }

  calle: string;
  numero: string;
  piso: string;
  departamento: string;
  localidad_name: string;
  partido_name: string;
  codigo_postal: string;

  numero_gestion: string;

  motivo_rechazo: string;

  state_id: string;

  attachs: RequestAttachment[];
}

export interface ConsultorioRenovacionRequestAttachs {
  tipo: string;
  tipo_archivo: string;
  url: string;
}

export interface RequestAttachment {
  id: number;
  request_id: number;
  request_type: string;
  attachment_type: string;
  url: string;
  created_at: string;
}

export interface GalleryItem {
  src: string;
  downloadUrl: string;
  alt: string;
}

function View() {
  const { id } = useParams();

  const [data, setData] = useState<ConsultorioRenovacionRequest>({
    id: id,
    matriculado: {
      matricula: 0,
      nombre: '',
      apellido: '',
      delegacion: '',
    },

    calle: '',
    numero: '',
    piso: '',
    departamento: '',
    localidad_name: '',
    partido_name: '',
    codigo_postal: '',

    numero_gestion: '',

    motivo_rechazo: '',

    state_id: '',

    attachs: [],
  });

  const [gallery, setGallery] = useState<GalleryItem[]>([]);
  const galleryContainer = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [stateText, setStateText] = useState('');

  const ATTACHMENTS_CONFIG = [
    { key: 'solicitud_habilitacion', alt: 'Solicitud de Renovación' },
    { key: 'constancia_pagos', alt: 'Constancia de Pagos' },
    { key: 'declaracion_aparatologia', alt: 'Declaración de Aparatologia' },
    { key: 'declaracion_patogenicos', alt: 'Declaración de Patogénicos' },
    { key: 'plano_municipal', alt: 'Plano Municipal' },
    { key: 'contrato_alquiler', alt: 'Contrato Alquiler' },
    { key: 'titulos_grado', alt: 'Título de Grado' },
    { key: 'constancia_cuit', alt: 'Constancia Cuit' },
    { key: 'resolucion_ministerio', alt: 'Resolución Ministerio' },
    { key: 'croquis_consultorio', alt: 'Croquis Consultorio' },
    { key: 'contrato_comodato', alt: 'Contrato Comodato' },
    { key: 'estatuto_societario', alt: 'Estatuto Societario' },
  ] as const;

  useEffect(() => {
    ApiService.getOne('matriculates/consultorios-renovacion-request', id)
      .then(({ payload }) => {
        setData(payload);

        const attachs = ATTACHMENTS_CONFIG.flatMap(({ key, alt }) => {
          if (!payload.attachs?.length) return [];

          const filtered = payload.attachs
            .filter((a: RequestAttachment) => a.attachment_type.startsWith(key))
            .sort((a: RequestAttachment, b: RequestAttachment) => {
              const indexA = parseInt(a.attachment_type.split('_').pop() || '0');
              const indexB = parseInt(b.attachment_type.split('_').pop() || '0');
              return indexA - indexB;
            });

          let i = 0;
          return filtered.map((a: RequestAttachment) => {
            const encodedPath = encodeFileName(a.url);
            i++;

            return {
              src: getPreviewSrc(encodedPath),
              downloadUrl: `${config.baseUrl}/${encodedPath}`,
              // @ts-ignore
              alt: `${alt} ${i}`,
            };
          });
        });

        setGallery(attachs);
      })
      .finally(() => setIsLoading(false));
  }, [id]);

  useEffect(() => {
    if (data.state_id != '') {
      switch (+data.state_id) {
        case 1:
          setStateText('Solicitado');
          break;
        case 2:
          setStateText('Aceptado');
          break;
        case 3:
          setStateText('Rechazado');
          break;
        case 4:
          setStateText('Enviado a Inspección');
          break;
        case 5:
          setStateText('Enviado Ministerio');
          break;
        case 6:
          setStateText('En Corrección');
          break;
        case 7:
          setStateText('Habilitado');
          break;
        default:
          setStateText('');
          break;
      }
    }
  }, [data.state_id]);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body"></div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Card className="bg-secondary shadow">
          <CardHeader>
            <Row>
              <Col md="8">
                <h3 className="mb-0">Solicitud de Renovación de Consultorio #{ id } - { stateText }</h3>
              </Col>
              <Col md="4" className="text-right">
                <Link to='/admin/matriculates/requests'>
                  <Button color="primary" size="md">Volver</Button>
                </Link>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form
              data={ data }
              gallery={ gallery }
              galleryContainer={ galleryContainer }
              isLoading={ isLoading }
              onChangeState={ false }
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default View;
